import styled from 'styled-components';

export const LoadingSpinnerWrapper = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 20px;
`;

export const SimpleGridWrapper = styled.div`
    [class*='SimpleGridstyle__SimpleGrid-sc'] {
        [class*='SimpleGridstyle__SimpleGridColumn-sc'] {
            padding: 10px;

            [class*='Interactionstyle__Button-sc'] {
                text-decoration: none;
                color: #333;
                
                [class*='LinkWithIconstyle__LinkWithIconText-sc'] {
                    text-align: justify;
                }

                div {
                    font-family: Vodafone;
                    font-weight: 200;
                    line-height: 28px;
                    @media (min-width: 1024px) {
                        font-size: 20px;
                    }
                }

                svg {
                    fill: var(--red);
                    stroke: var(--red);
                }
            }
        }
    }
`;

export const ToptenOuter = styled.div`
  padding: 0 15px;
`;